import BatabotActionTypes from "./batabot.types";

//ACTION CREATORS

export const getBatabotAccess = (payload) => ({
  type: BatabotActionTypes.GET_ACCESS,
  payload,
});
